import { c as _c } from "react/compiler-runtime";
import { isValidElement, cloneElement, type JSX } from 'react';
import { colors } from '../../../../theme/colors';
import { cn } from '../../../../v2';
import { Badge } from '../../../badge';
import { ExpandableBody, ExpandableRow } from '../../../expandable-row';
import { TextEyebrow } from '../../../text-eyebrow';
import type { BaseCardProps } from '../../types';
import { IconTitleSubtitleBlock } from '../icon-title-subtitle-block';
import { SelectableControl } from '../selectable-control';
export function DefaultSizeDetailCard(props) {
  const $ = _c(67);
  const {
    actions,
    assistiveText,
    badgeProps,
    eyebrowProps,
    icon,
    subtitle,
    subtitleComponent,
    title,
    children,
    hasActions,
    expanded,
    setExpanded,
    selectableOptions,
    isSelectable,
    isExpandable,
    isHighlighted,
    hasEyebrow,
    showSubtitleComponentWhenExpanded,
    titleColor: t0,
    testId,
    disabledProps,
    highlightColor
  } = props;
  const titleColor = t0 === undefined ? "black" : t0;
  const hasBadge = !!badgeProps;
  let t1;
  if ($[0] !== disabledProps) {
    t1 = disabledProps ?? {};
    $[0] = disabledProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isDisabled
  } = t1;
  const innerPaddingClassName = `p-1`;
  let t2;
  if ($[2] !== isDisabled || $[3] !== isSelectable || $[4] !== selectableOptions || $[5] !== testId) {
    t2 = isSelectable && <div className={innerPaddingClassName}><SelectableControl selectableOptions={selectableOptions} testId={testId} disabled={isDisabled} /></div>;
    $[2] = isDisabled;
    $[3] = isSelectable;
    $[4] = selectableOptions;
    $[5] = testId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== expanded || $[8] !== eyebrowProps?.color || $[9] !== eyebrowProps?.text || $[10] !== hasEyebrow || $[11] !== highlightColor || $[12] !== icon || $[13] !== isExpandable || $[14] !== isHighlighted || $[15] !== setExpanded || $[16] !== showSubtitleComponentWhenExpanded || $[17] !== subtitle || $[18] !== subtitleComponent || $[19] !== testId || $[20] !== title || $[21] !== titleColor) {
    t3 = <div className="flex flex-col justify-center">{hasEyebrow ? <div className={innerPaddingClassName}><TextEyebrow color={eyebrowProps?.color ? eyebrowProps?.color : colors.brand[400]} data-testid={`${testId}-eyebrow`}>{eyebrowProps?.text}</TextEyebrow></div> : <div className={innerPaddingClassName}><IconTitleSubtitleBlock expanded={expanded} showSubtitleComponentWhenExpanded={showSubtitleComponentWhenExpanded} icon={icon} setExpanded={setExpanded} showChevron={isExpandable} subtitle={subtitle} subtitleComponent={subtitleComponent} title={title} titleColor={titleColor} isHighlighted={isHighlighted} testId={testId} highlightColor={highlightColor} /></div>}</div>;
    $[7] = expanded;
    $[8] = eyebrowProps?.color;
    $[9] = eyebrowProps?.text;
    $[10] = hasEyebrow;
    $[11] = highlightColor;
    $[12] = icon;
    $[13] = isExpandable;
    $[14] = isHighlighted;
    $[15] = setExpanded;
    $[16] = showSubtitleComponentWhenExpanded;
    $[17] = subtitle;
    $[18] = subtitleComponent;
    $[19] = testId;
    $[20] = title;
    $[21] = titleColor;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("flex items-center", `gap-[6px]`, innerPaddingClassName);
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== badgeProps || $[25] !== hasBadge || $[26] !== testId) {
    t5 = hasBadge && <Badge type={badgeProps?.type ? badgeProps.type : "success"} size="small" testId={testId}>{badgeProps.content}</Badge>;
    $[24] = badgeProps;
    $[25] = hasBadge;
    $[26] = testId;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== actions || $[29] !== hasActions || $[30] !== isDisabled || $[31] !== title) {
    t6 = hasActions && actions?.map((action, i) => <div key={`action-for-${title}-${i}`}>{isDisabled && isValidElement(action) ? cloneElement(action as JSX.Element, {
        disabled: isDisabled
      }) : action}</div>);
    $[28] = actions;
    $[29] = hasActions;
    $[30] = isDisabled;
    $[31] = title;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== t5 || $[34] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  let t8;
  if ($[36] !== t3 || $[37] !== t7) {
    t8 = <div className="flex items-center justify-between">{t3}{t7}</div>;
    $[36] = t3;
    $[37] = t7;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== expanded || $[40] !== hasEyebrow || $[41] !== icon || $[42] !== isExpandable || $[43] !== setExpanded || $[44] !== showSubtitleComponentWhenExpanded || $[45] !== subtitle || $[46] !== subtitleComponent || $[47] !== testId || $[48] !== title || $[49] !== titleColor) {
    t9 = hasEyebrow && <IconTitleSubtitleBlock expanded={expanded} showSubtitleComponentWhenExpanded={showSubtitleComponentWhenExpanded} icon={icon} setExpanded={setExpanded} showChevron={isExpandable} subtitle={subtitle} subtitleComponent={subtitleComponent} title={title} titleColor={titleColor} testId={testId} />;
    $[39] = expanded;
    $[40] = hasEyebrow;
    $[41] = icon;
    $[42] = isExpandable;
    $[43] = setExpanded;
    $[44] = showSubtitleComponentWhenExpanded;
    $[45] = subtitle;
    $[46] = subtitleComponent;
    $[47] = testId;
    $[48] = title;
    $[49] = titleColor;
    $[50] = t9;
  } else {
    t9 = $[50];
  }
  let t10;
  if ($[51] !== t8 || $[52] !== t9) {
    t10 = <div className="flex flex-col">{t8}{t9}</div>;
    $[51] = t8;
    $[52] = t9;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  let t11;
  if ($[54] !== assistiveText || $[55] !== children || $[56] !== testId) {
    t11 = (children || assistiveText) && <div className={innerPaddingClassName}>{children}{assistiveText && <div className="pt-1"><div className="text-sm font-light" data-testid={`${testId}-assistive-text`}>{assistiveText}</div></div>}</div>;
    $[54] = assistiveText;
    $[55] = children;
    $[56] = testId;
    $[57] = t11;
  } else {
    t11 = $[57];
  }
  let t12;
  if ($[58] !== t11) {
    t12 = <ExpandableBody paddingX={0} paddingBottom={0}>{t11}</ExpandableBody>;
    $[58] = t11;
    $[59] = t12;
  } else {
    t12 = $[59];
  }
  let t13;
  if ($[60] !== expanded || $[61] !== t10 || $[62] !== t12) {
    t13 = <div className="flex flex-1 flex-col justify-center"><ExpandableRow removeStyling={true} expanded={expanded}>{t10}{t12}</ExpandableRow></div>;
    $[60] = expanded;
    $[61] = t10;
    $[62] = t12;
    $[63] = t13;
  } else {
    t13 = $[63];
  }
  let t14;
  if ($[64] !== t13 || $[65] !== t2) {
    t14 = <div className="flex">{t2}{t13}</div>;
    $[64] = t13;
    $[65] = t2;
    $[66] = t14;
  } else {
    t14 = $[66];
  }
  return t14;
}